import { getFormValues, setFormValues } from "@/components/layout/list/defaultTypeCheck";
import { FormInstance } from "antd";
import { Debug } from "./debug";
import { objEquals } from "./arrayutil";
import { getFormMemo, runFormFunction } from "@/components/layout/input/inputFunction";
import { checkEmpty, strCapitalize } from "./stringutil";

const getSqlParam = (str: string) => {
  return `#{${str}}`;
};
const getSqlEq = (str: string, field?: string, like?: boolean) => {
  return like ? `${field ?? str} like concat('%',${getSqlParam(str)},'%')` : `${field ?? str} = ${getSqlParam(str)}`;
};
const getSqlUp = (str: string) => {
  //  return `<if test="UpdateParameterList != null and UpdateParameterList instanceof java.util.List and UpdateParameterList.contains('${str}')">${getSqlEq(str)},</if>`;
  return `<if test="@MybatisUtil@checkUP(UPList,'${str}')">${getSqlEq(str)},</if>`;
};
//<if test="${value.system_table_pk_mybatis_str}>\r\n` +
// `        OR (${value.system_table_pk_sql_str}})\r\n` +
// `			</if>
const getMybatisIfNotEmpty = (str: string, field?: string) => {
  return (
    `\r\n                <if test="${str} != null and !${str}.equals('')">\r\n` +
    `                AND ${getSqlEq(str, field)}\r\n` +
    `                </if>`
  );
};
const getMybatisIfEq = (str: string, field?: string, title?: string, like?: boolean) => {
  return (
    `\r\n                <if test="${str} != null and ${str}.equals('${field ?? str}')">\r\n` +
    `                AND ${getSqlEq(title ?? str, field ?? str, like)}\r\n` +
    `                </if>`
  );
};
const getMybatisIfOrderList = (str_list: string[]) => {
  return str_list.map((str) => getMybatisIfOrderStr(str));
};
const getMybatisIfOrderStr = (str: string) => {
  return (
    `\r\n            <if test="orderType != null and orderType.equals('${str}_orderasc')">${str} ASC</if>` +
    `\r\n            <if test="orderType != null and orderType.equals('${str}_orderdesc')">${str} DESC</if>`
  );
};
const getMybatisWhenOrderList = (str_list: string[]) => {
  return str_list.map((str) => getMybatisWhenOrderStr(str));
};
const getMybatisWhenOrderStr = (str: string) => {
  return (
    `\r\n            <when test='"${str}_orderasc".equals(orderType)'>${str} ASC</when>` +
    `\r\n            <when test='"${str}_orderdesc".equals(orderType)'>${str} DESC</when>`
  );
};
const getMybatisEqStr = (str: string, eq?: boolean) => {
  return eq ? `(${str} == null or ${str}.equals(''))` : `${str} != null and !${str}.equals('')`;
};
const getMybatisEqStrJoin = (str_list: string[], str_prev?: string, eq?: boolean) => {
  return str_list
    .map((str, index) => {
      return getMybatisEqStr(str_prev ? str_prev + index : str, eq);
    })
    .join(" and ");
};
const getMybatisEqListFront = (str_list: string[], str_prev?: string, eq?: boolean) => {
  return '<if test="' + getMybatisEqStrJoin(str_list, str_prev, eq) + '">';
};
const getMybatisEqListInner = (str_list: string[], str_prev?: string, eq?: boolean) => {
  return str_list.map((field, index) => getSqlEq(str_prev ? str_prev + index : field, field, eq)).join(" and ");
};

const getMybatisEqList = (str_list: string[], str_prev?: string, eq?: boolean) => {
  return (
    "\r\n			" +
    getMybatisEqListFront(str_list, str_prev, eq) +
    "\r\n" +
    "        OR (" +
    getMybatisEqListInner(str_list, str_prev, eq) +
    ")\r\n" +
    "			</if>"
  );
};

const getSqlNow = (str: string) => {
  return `${str} = now()`;
};
const getUserSeq = (str: string) => {
  return `${str} = #{user_seq}`;
};
const getExcelChar = (type: string | undefined, i: number, row: number) => {
  //const result = '"&' + String.fromCharCode(65 + i) + row + '&"';
  const j = Math.floor(i / 26);
  const k = i % 26;
  const a = i > 25 ? String.fromCharCode(65 + (j - 1)) : "";
  const c = a + String.fromCharCode(65 + k) + row;
  if (type === "varchar" || type === "text") {
    return '"\'"&' + c + '&"\'"';
  } else {
    1;
    return c;
  }
  //return type === "varchar" || type === "text" ? "'" + result + "'" : result;
};
const getExcelCheckNullChar = (type: string | undefined, i: number, row: number) => {
  return '"&IF(' + getExcelChar(undefined, i, row) + '="","NULL",' + getExcelChar(type, i, row) + ')&"';
  // if (type === "varchar" || type === "text") {
  // } else {
  //   return '"&IF(' + String.fromCharCode(65 + i) + row + '="","NULL",' + String.fromCharCode(65 + i) + row + ')&"';
  // }
  //return type === "varchar" || type === "text" ? "'" + result + "'" : result;
};
const getExcelEq = (str: string, type: string | undefined, i: number, row: number) => {
  return `${str} = ` + getExcelCheckNullChar(type, i, row);
};
export const getChangeValues = (form: FormInstance<any>, value: any, org: any) => {
  const notChanges: Record<string, any> = {};
  const changes: Record<string, any> = {};
  const value_check_field = ["COLUMN_TYPE", "CHECK_LIST", "COLUMN_CODE_SELECT"];
  const fields: Record<string, any> = {};
  const org_data = org ? JSON.parse(JSON.stringify(org)) : undefined;
  if (org_data instanceof Array) {
    org_data.forEach((item, index) => {
      if (item["COLUMN_NAME"] && !fields[item["COLUMN_NAME"]]) {
        //field_list.push(item["COLUMN_NAME"]);
        fields[item["COLUMN_NAME"]] = item;
      }
      value_check_field.forEach((key: string) => {
        const org_value = item[key];
        const check_value = form.getFieldValue(key + "_" + index);
        const change = objEquals(org_value, check_value);
        if (change) {
          //changes[key + "_" + index] = check_value;
          if (!changes[item["COLUMN_NAME"]]) {
            changes[item["COLUMN_NAME"]] = {};
          }
          changes[item["COLUMN_NAME"]][key] = check_value;

          if (!fields[item["COLUMN_NAME"]]) {
            fields[item["COLUMN_NAME"]] = item;
          }
          if (fields[item["COLUMN_NAME"]]) {
            fields[item["COLUMN_NAME"]][key] = check_value;
          }
        } else {
          notChanges[key + "_" + index] = check_value;
        }
      });
    });
  }
  return { fields, changes, notChanges };
};
const start_str = "//--info--";
export const getCheckedInfoDataStr = (str: string) => {
  if (str !== undefined) {
    const str_arr = str.split(/\r\n|\n/gi);
    return str_arr
      .map((item: string) => {
        Debug(item);
        const item_trim = item ? item.trim() : "";
        if (item.trim().indexOf(start_str) === 0) {
          return item_trim.substring(start_str.length, item_trim.length);
        } else {
          return undefined;
        }
      })
      .filter((item) => item !== undefined)
      .join("\r\n");
  } else {
    return undefined;
  }
};
export const getInfoDataStr = (value: any, changed: any) => {
  const value_str = value !== undefined && Object.keys(value).length > 0 ? JSON.stringify(value) : undefined;
  const changed_str = changed !== undefined && Object.keys(changed).length > 0 ? JSON.stringify(changed) : undefined;
  return (
    `    ${start_str}{\r\n` +
    (value_str ? `    ${start_str}"table":${value_str}` + (changed_str ? "," : "") + `\r\n` : "") +
    (changed_str ? `    ${start_str}"change":${changed_str}\r\n` : "") +
    `    ${start_str}}\r\n`
  );
};
export const setFormConvertValues = (
  form: FormInstance | undefined,
  formMemo: Record<string, any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  target: string,
  changed: any
) => {
  const memo = getFormMemo(formMemo, target);
  const convert: Record<string, any> = {};
  if (memo.orgSubListData && memo.orgSubListData instanceof Array) {
    memo.orgSubListData.forEach((item: any, index: any) => {
      if (changed[item[target]]) {
        const obj = changed[item[target]];
        Object.keys(obj).forEach((key) => {
          convert[key + "_" + index] = JSON.parse(JSON.stringify(obj[key]));
        });
      }
    });
  }
  Debug(memo, convert);
  if (convert && Object.keys(convert).length > 0) {
    setFormValues(form, convert);
    Object.keys(convert).forEach((item) => {
      Debug(item, form?.getFieldValue(item));
      if (item.indexOf("CHECK_LIST") > -1) {
        setTimeout(() => {
          const run = runFormFunction(formFunction, item, "setValue", convert[item]);
          Debug(run);
        }, 1000);
      }
    });
  }
  return convert;
};
export const getCodeStringObj = (form: FormInstance<any>, value: any, org: any) => {
  const fields: Record<string, any> = {}; //getFields();
  //const field_list: Record<string, string[]> = {};
  //fields.list:string[] = [];
  fields.dataCols = [];
  fields.listCols = [];
  fields.list = [];
  fields.search = [];
  fields.read = [];
  fields.insert = [];
  fields.insert1 = [];
  fields.insert2 = [];
  fields.update = [];
  fields.update1 = [];
  fields.update2 = [];
  fields.excelin1 = [];
  fields.excelin2 = [];
  fields.excelup = [];
  fields.pk_ai = [];

  const pk_list: string[] = [];
  //fields.fields = [];
  fields.pk_list = pk_list;
  const changeObj = getChangeValues(form, value, org);
  const infoDataStr = getInfoDataStr(value, changeObj.changes);
  fields.fields = changeObj.fields;
  Debug(org, fields.fields, changeObj.notChanges, changeObj.changes);
  //value: any, fields: any, changes: any
  //value.str = JSON.stringify(value);
  //fields.changed_str = JSON.stringify(changeObj.changes);
  //
  //field_list ["LIST", "READ", "CREATE", "UPDATE", "EXCEL_IN", "EXCEL_UP"]
  let excelin_count = 0;
  let excelup_count = value.system_table_pk ? value.system_table_pk.length : 0;
  Object.keys(fields.fields).forEach((key) => {
    //TABLE_SCHEMA,TABLE_NAME,COLUMN_NAME,DATA_TYPE,ORDINAL_POSITION,COLUMN_DEFAULT,IS_NULLABLE,CHARACTER_MAXIMUM_LENGTH,COLUMN_KEY,EXTRA,COLUMN_COMMENT //"COLUMN_TYPE", "COLUMN_CODE_SELECT", "CHECK_LIST"
    const obj = fields.fields[key];
    if (obj) {
      const check_list: string[] = obj.CHECK_LIST;
      if (obj.COLUMN_KEY === "PRI" && obj.EXTRA === "auto_increment") {
        fields.pk_ai.push(key);
      }
      if (check_list) {
        if (check_list.includes("LIST")) {
          if (value.system_table_pk && value.system_table_pk.includes(key)) {
          } else {
            fields.list.push(key);
          }
          const notAnnt =
            (value.system_table_pk && value.system_table_pk.includes(key)) ||
            (value.system_table_search_column && value.system_table_search_column.includes(key)) ||
            key === value.system_table_default_name_column ||
            key === value.system_table_en_name_column;

          const listCols_str =
            (notAnnt ? "" : "//") +
            (obj.COLUMN_CODE_SELECT
              ? `{ field: "${key}", codeGroup: "${obj.COLUMN_CODE_SELECT}", inputDirect: "${key}", selectProp: { mode: "multiple" } }`
              : `"${key}"`);
          fields.listCols.push(listCols_str);
        }
        if (check_list.includes("READ")) {
          if (key === "rgst_at" || key === "edit_at") {
          } else if (key === "rgst_by" || key === "edit_by") {
          } else {
            if (value.system_table_pk && value.system_table_pk.includes(key)) {
            } else {
              fields.read.push(key);
            }
          }
          const dataCols_str =
            "\r\n        " +
            (obj.COLUMN_TYPE ? "" : "//") +
            `${key}:{...dc.${obj.COLUMN_TYPE}` +
            (obj.IS_NULLABLE === "NO" ? `, required: true` : ``) +
            (obj.IS_NULLABLE === "NO" && obj.DATA_TYPE === "varchar" ? `, minLength: 3` : ``) +
            (obj.DATA_TYPE === "varchar" ? `, maxLength: ${obj.CHARACTER_MAXIMUM_LENGTH}, showCount: true` : ``) +
            (obj.DATA_TYPE === "text" ? `, maxLength: 10000, showCount: true` : ``) +
            (obj.COLUMN_CODE_SELECT
              ? `, codeGroup: "${obj.COLUMN_CODE_SELECT}", inputDirect: "${key}", selectProp: { mode: "multiple" }`
              : ``) +
            `}`;
          fields.dataCols.push(dataCols_str);
        }
        if (check_list.includes("CREATE")) {
          fields.insert1.push(key);
          if (key === "rgst_at" || key === "edit_at") {
            fields.insert2.push("now()");
          } else if (key === "rgst_by" || key === "edit_by") {
            fields.insert2.push("#{user_seq}");
          } else {
            if (value.system_table_pk && value.system_table_pk.includes(key)) {
            } else {
              fields.insert.push(key);
            }
            fields.insert2.push(getSqlParam(key));
          }
        }
        if (check_list.includes("UPDATE")) {
          if (key === "rgst_at" || key === "edit_at") {
            fields.update1.push(getSqlNow(key) + ",");
          } else if (key === "rgst_by" || key === "edit_by") {
            fields.update1.push(getUserSeq(key) + ",");
          } else {
            if (value.system_table_pk && value.system_table_pk.includes(key)) {
            } else {
              fields.update.push(key);
            }
            fields.update1.push(getSqlUp(key));
            fields.update2.push(key);
          }
        }
        if (check_list.includes("EXCEL_IN")) {
          fields.excelin1.push(key);
          fields.excelin2.push(getExcelCheckNullChar(obj.DATA_TYPE, excelin_count, 2));
          excelin_count++;
        }
        if (check_list.includes("EXCEL_UP")) {
          fields.excelup.push(getExcelEq(key, obj.DATA_TYPE, excelup_count, 2));
          excelup_count++;
        }
      }
    }
  });

  fields.dataCols_str = fields.dataCols.join(",");
  fields.listCols_str = fields.listCols.join(",\r\n			");
  fields.list_str = fields.list.join(",\r\n			");
  fields.read_str = fields.read.join(",\r\n			");
  fields.insert1_str = fields.insert1.join(",\r\n			");
  fields.insert2_str = fields.insert2.join(",\r\n			");
  fields.update1_str = fields.update1.join("\r\n			");
  fields.update2_str = fields.update2.join("|");
  fields.excelin1_str = fields.excelin1.join(",");
  fields.excelin2_str = fields.excelin2.join(",");
  fields.excelup_str = fields.excelup.join(",");

  fields.search_str = value.system_table_search_column
    ? value.system_table_search_column instanceof Array
      ? value.system_table_search_column
          .map((str: string, index: number) => getMybatisIfNotEmpty("search" + index, str))
          .join("")
      : getMybatisIfNotEmpty("search", value.system_table_search_column)
    : "";
  fields.listSearch_str = value.system_table_search_column
    ? value.system_table_search_column instanceof Array
      ? value.system_table_search_column
          .map((str: string, index: number) => {
            const obj = fields.fields[str];
            return (
              (obj.COLUMN_TYPE ? `{...dc.${obj.COLUMN_TYPE}, ` : `{ `) +
              (obj?.COLUMN_CODE_SELECT ? `inputType:"select", codeGroup: "${obj.COLUMN_CODE_SELECT}", ` : ``) +
              `field:"search${index}", label:"${str}", placeholder:"${str}"` +
              `}`
            );
          })
          .join(",\r\n")
      : `{field:"search", label:"${value.system_table_search_columntr}" placeholder:"${value.system_table_search_column}"}`
    : "";
  fields.search_select_str = value.system_table_search_select
    ? value.system_table_search_select instanceof Array
      ? (value.system_table_search_select.length > 1
          ? `<if test="searchType != null and searchType.equals('search_title_all')">\r\n                    AND (` +
            value.system_table_search_select
              .map((str: string) => getSqlEq("searchTitle", str, true))
              .join(" or \r\n                    ") +
            `)\r\n                    </if>`
          : "") +
        value.system_table_search_select
          .map((str: string, index: number) => `` + getMybatisIfEq("searchType", str, "searchTitle", true))
          .join("")
      : getMybatisIfEq("searchType", value.system_table_search_select, "searchTitle", true)
    : "";
  fields.listSearchSelect_str = value.system_table_search_select
    ? value.system_table_search_select instanceof Array
      ? value.system_table_search_select
          .map((str: string, index: number) => {
            const obj = fields.fields[str];
            return (
              (obj.COLUMN_TYPE ? `{...dc.${obj.COLUMN_TYPE}, ` : `{ `) +
              (obj?.COLUMN_CODE_SELECT ? `inputType:"select", codeGroup: "${obj.COLUMN_CODE_SELECT}", ` : ``) +
              `field:"search_type${index}", label:"${str}", placeholder:"${str}"` +
              `}`
            );
          })
          .join(",\r\n")
      : `{field:"search_type", label:"${value.system_table_search_select}" placeholder:"${value.system_table_search_select}"}`
    : "";
  fields.order_str = value.system_table_order_column
    ? value.system_table_order_column instanceof Array
      ? getMybatisWhenOrderList(value.system_table_order_column).join("")
      : getMybatisWhenOrderStr(value.system_table_order_column)
    : "";
  fields.listOrder_str = value.system_table_order_column
    ? value.system_table_order_column instanceof Array
      ? value.system_table_order_column
          .map((str: string, index: number) => `"${str}_orderdesc","${str}_orderasc"`)
          .join(",")
      : `"${value.system_table_order_column}_orderdesc","${value.system_table_order_column}_orderasc"`
    : "";

  if (value.system_table_pk) {
    //Debug(value.system_table_auth);
    value.system_table_pk_str = value.system_table_pk.join(",");
    value.system_table_auth_pk = [...value.system_table_pk];
    if (!checkEmpty(value.system_select_auth)) {
      const check_system_select_auth = value.system_select_auth.map((item: string) => item + "_seq");
      Debug(check_system_select_auth);
      value.system_table_auth_pk = value.system_table_auth_pk.filter(
        (item: string) => !check_system_select_auth.includes(item)
      );
    }
    value.system_table_pk_list_str =
      value.system_table_auth_pk.length === 1
        ? '"' + value.system_table_auth_pk[0] + '"'
        : '["' + value.system_table_auth_pk.join('","') + '"]';
    value.system_table_pk_request_str = "/{" + value.system_table_auth_pk.join("}/{") + "}";
    value.system_table_pk_sql_str = value.system_table_pk.map((str: string) => getSqlEq(str)).join(" AND ");
    value.system_table_pk_mybatis_str = getMybatisEqList(value.system_table_pk);
    value.system_table_pk_excel_str = value.system_table_pk
      .map((str: string, index: number) => getExcelEq(str, "varchar", index, 2))
      .join(" AND ");
    value.system_table_auth_str = value.system_table_auth
      ? value.system_table_auth.length === 0
        ? "false"
        : value.system_table_auth.length === 1 && value.system_table_auth[0] === "USER"
        ? "true"
        : '"' + value.system_table_auth.join("|") + '"'
      : "false";
  } else {
    value.system_table_pk_str = "";
    value.system_table_pk_list_str = "";
    value.system_table_pk_request_str = "";
    value.system_table_pk_sql_str = "";
    value.system_table_pk_mybatis_str = "";
    value.system_table_pk_excel_str = "";
    value.system_table_auth_str = "";
  }
  // //파기 코드 시작
  // const old_common_fixedstr =
  //   ` <sql id="select${value.system_table_page_name}CommonWhere">\r\n` +
  //   `   WHERE 1=1${fields.search_str}\r\n` +
  //   (fields.search_select_str === ""
  //     ? ""
  //     : `     <if test="searchType!=null and !searchType.equals('') and searchTitle!=null and !searchTitle.equals('')">\r\n     ${fields.search_select_str}\r\n     </if>\r\n`) +
  //   ` </sql>\r\n`;
  // const old_order_fixedstr =
  //   `   ORDER BY${fields.order_str}\r\n` +
  //   // `     ${fields.order_str === "" ? "" : ","}\r\n` +
  //   `     <if test="orderType == null and (NEXT_LOCALE!=null and !NEXT_LOCALE.equals('') and !NEXT_LOCALE.equals('en'))">${value.system_table_default_name_column}</if>\r\n` +
  //   `     <if test="orderType == null and (NEXT_LOCALE==null or NEXT_LOCALE.equals('') or NEXT_LOCALE.equals('en'))">${value.system_table_en_name_column}</if>\r\n`;
  // //old code
  // const old_mybatis_fixedstr =
  //   ` <!-- ${value.system_table_page_name} Start -->\r\n` +
  //   `${old_common_fixedstr}` +
  //   `    <select id="select${value.system_table_page_name}List" parameterType="hashmap" resultType="linkmap">\r\n` +
  //   `        SELECT\r\n` +
  //   `            ${fields.list_str}\r\n` +
  //   `        FROM ${value.system_TABLE_SCHEMA}.${value.system_TABLE_NAME}\r\n` +
  //   `        <include refid="select${value.system_table_page_name}CommonWhere" />\r\n` +
  //   `${old_order_fixedstr}` +
  //   `        <include refid="common.limitPage" />\r\n` +
  //   `    </select>\r\n` +
  //   `    <select id="select${value.system_table_page_name}ListCount" parameterType="hashmap" resultType="int">\r\n` +
  //   `        SELECT\r\n` +
  //   `            count(*)\r\n` +
  //   `        FROM ${value.system_TABLE_SCHEMA}.${value.system_TABLE_NAME}\r\n` +
  //   `        <include refid="select${value.system_table_page_name}CommonWhere" />\r\n` +
  //   `    </select>\r\n` +
  //   `    <select id="select${value.system_table_page_name}Detail" parameterType="hashmap" resultType="linkmap">\r\n` +
  //   `        SELECT\r\n` +
  //   `            ${fields.read_str}\r\n` +
  //   `        FROM ${value.system_TABLE_SCHEMA}.${value.system_TABLE_NAME}\r\n` +
  //   `        WHERE 1=0${value.system_table_pk_mybatis_str}\r\n` +
  //   `    </select>\r\n` +
  //   (value.system_table_pk !== undefined && value.system_table_pk.length > 1
  //     ? `    <select id="select${value.system_table_page_name}Uniq" parameterType="java.util.HashMap" resultType="int">\r\n` +
  //       `    SELECT\r\n` +
  //       `    ${getMybatisEqListFront(value.system_table_pk, undefined, true)}1</if>\r\n` +
  //       `     ${getMybatisEqListFront(value.system_table_pk, undefined, false)}(SELECT count(*) FROM ${
  //         value.system_TABLE_SCHEMA
  //       }.${value.system_TABLE_NAME} WHERE ${value.system_table_pk_sql_str})</if>\r\n` +
  //       `    as cnt FROM DUAL\r\n` +
  //       `    </select>\r\n`
  //     : "") +
  //   `    <insert id="insert${value.system_table_page_name}Detail" parameterType="java.util.HashMap" useGeneratedKeys="true" keyProperty="${value.system_table_pk_str}">\r\n` +
  //   (value.system_table_pk !== undefined && value.system_table_pk.length > 1
  //     ? `        <selectKey keyProperty="${value.system_table_pk[1]}" resultType="int" order="BEFORE">\r\n` +
  //       `        SELECT COALESCE(max(${value.system_table_pk[1]}),0) + 1 as seq from ${value.system_TABLE_SCHEMA}.${value.system_TABLE_NAME} where ${value.system_table_pk[0]} = #{${value.system_table_pk[0]}}\r\n` +
  //       `        </selectKey>\r\n`
  //     : "") +
  //   `        INSERT INTO ${value.system_TABLE_SCHEMA}.${value.system_TABLE_NAME} \r\n` +
  //   `            (${fields.insert1_str}\r\n` +
  //   `        ) VALUES (\r\n` +
  //   `            ${fields.insert2_str})\r\n` +
  //   `    </insert>\r\n` +
  //   `    <update id="update${value.system_table_page_name}Detail" parameterType="java.util.HashMap">\r\n` +
  //   `        UPDATE ${value.system_TABLE_SCHEMA}.${value.system_TABLE_NAME} SET \r\n` +
  //   `            ${fields.update1_str}\r\n` +
  //   `        WHERE\r\n` +
  //   `            1=0\r\n` +
  //   `            <if test="${
  //     value.system_table_pk !== undefined ? getMybatisEqStrJoin(value.system_table_pk) + " and " : ""
  //   }@MybatisUtil@checkUPList(UPList,'${fields.update2_str}')">\r\n` +
  //   `            or (${value.system_table_pk_sql_str})\r\n` +
  //   `            </if>\r\n` +
  //   `    </update>\r\n` +
  //   `    <!-- ${value.system_table_page_name} End -->\r\n` +
  //   `    <select id="select${value.system_table_page_name}List" parameterType="hashmap" resultType="linkmap">\r\n` +
  //   `        SELECT\r\n` +
  //   `            ${fields.read_str}\r\n` +
  //   `        FROM ${value.system_TABLE_SCHEMA}.${value.system_TABLE_NAME}\r\n` +
  //   `        <include refid="select${value.system_table_page_name}CommonWhere" />\r\n` +
  //   `        <if test="last_edit_at != null  and !last_edit_at.equals('')">\r\n` +
  //   `            AND (SELECT COUNT(*) FROM ${value.system_TABLE_SCHEMA}.${value.system_TABLE_NAME} <include refid="select${value.system_table_page_name}CommonWhere" />\r\n` +
  //   `            AND edit_at <![CDATA[>]]> #{last_edit_at}) <![CDATA[>]]> 0\r\n` +
  //   `        </if>\r\n` +
  //   `        <include refid="common.limitPage" />\r\n` +
  //   `    </select>\r\n` +
  //   `    <sql id="select${value.system_table_page_name}CommonWhere">\r\n` +
  //   `        WHERE (1=0${value.system_table_pk_mybatis_str})\r\n` +
  //   `            AND _use = 1\r\n` +
  //   `    </sql>`;
  // //파기 코드 끝

  const info_fixedstr = `${infoDataStr}`;
  const list_fixedstr =
    (fields.listSearch_str === "" ? "" : `        listSearch:[${fields.listSearch_str}],\r\n`) +
    (fields.listSearchSelect_str === ""
      ? ""
      : `        listSearchSelect:[{ ...dc.input, field: "search_title_all", label: "${value.system_table_default_name_column}", placeholder: "${value.system_table_default_name_column}"},\r\n${fields.listSearchSelect_str}],\r\n`) +
    (fields.listOrder_str === "" ? "" : `        listOrder:[${fields.listOrder_str}],\r\n`);

  const javascript_fixedstr =
    `${info_fixedstr}` +
    // `    //{table:${value.str}\r\n` +
    // `    //{change:${fields.changed_str}}\r\n` +
    `    case "${value.system_table_page}":\r\n` +
    `      return {\r\n` +
    `        ...result,\r\n` +
    `        dataFetch: { fetchUrl: "/api/${value.system_table_path}/detail/",\r\n` +
    `        saveFetch: { fetchUrl: "/api/${value.system_table_path}/edit" } },\r\n` +
    `        listFetch: { fetchUrl: "/api/${value.system_table_path}/list" },\r\n` +
    `        dataResultName: "${value.system_table_detail_result}",\r\n` +
    `        dataName: "${value.system_table_page_name}Data",\r\n` +
    `        dataCols: { ${fields.dataCols_str} },\r\n` +
    `        listColLinkField: ${value.system_table_pk_list_str},\r\n` +
    `${list_fixedstr}` +
    `        listCols: [\r\n` +
    `          ${fields.listCols_str}\r\n` +
    `       ],}\r\n`;
  const javaauth_fixedstr =
    (!checkEmpty(value.system_select_auth)
      ? value.system_select_auth
          .map((item: string) => {
            //권한설정관련
            const str = strCapitalize(item);
            const field_name = "system_" + item + "_auth";
            return !checkEmpty(value[field_name]) ? `getAuthSQLStr(${value[field_name]}UP)` : "";
          })
          .join(" + ")
      : '""') + '\r\n                + "||';

  const java_fixedstr =
    `    @RequestMapping("/api/${value.system_table_path}/list")\r\n` +
    `    public Header<?> get${value.system_table_page_name}List(HttpServletRequest request, Authentication authentication,\r\n` +
    `            @RequestBody(required = false) Map<String, Object> map) {\r\n` +
    `        return Header.SQL(${javaauth_fixedstr}GETPAGELIST-${value.system_table_mapper}.select${value.system_table_page_name}ListCount,${value.system_table_mapper}.select${value.system_table_page_name}List/auth-user_seq", null, request,\r\n` +
    `                authentication, new ValidateAuthList(${value.system_table_auth_str}), map, null);\r\n` +
    `    }\r\n` +
    `    @RequestMapping("/api/${value.system_table_path}/detail${value.system_table_pk_request_str}` +
    `")\r\n` +
    `    public Header<?> get${value.system_table_page_name}Detail(HttpServletRequest request, Authentication authentication,\r\n` +
    `            @RequestBody(required = false) Map<String, Object> map) {\r\n` +
    `        return Header.SQL(${javaauth_fixedstr}GETDATA-${value.system_table_detail_result}:${value.system_table_mapper}.select${value.system_table_page_name}Detail/auth-user_seq", null, request, authentication,\r\n` +
    `                new ValidateAuthList(${value.system_table_auth_str}), map, null);\r\n` +
    `    }\r\n` +
    `    @RequestMapping("/api/${value.system_table_path}/edit")\r\n` +
    `    public Header<?> edit${value.system_table_page_name}Detail(HttpServletRequest request, Authentication authentication,\r\n` +
    `            @RequestBody(required = false) Map<String, Object> map) {\r\n` +
    `        return Header.SQL(${javaauth_fixedstr}` +
    (checkEmpty(fields.pk_ai) && checkEmpty(value.system_table_manual_increment)
      ? `UPSERT-edit_result:${value.system_table_mapper}.select${value.system_table_page_name}Uniq,${value.system_table_mapper}.insert${value.system_table_page_name}Detail,${value.system_table_mapper}.update${value.system_table_page_name}Detail,${value.system_table_pk_str}/auth-user_seq` +
        (!checkEmpty(value.system_table_pk) ? `/run-map:${value.system_table_pk.join(",notNull-map:")},notNull"` : "") +
        `\r\n`
      : `UPSERTPK-edit_result:${value.system_table_mapper}.insert${value.system_table_page_name}Detail,${value.system_table_mapper}.update${value.system_table_page_name}Detail,${value.system_table_pk_str}/auth-user_seq/mapToResult-${value.system_table_pk_str}:${value.system_table_pk_str}"\r\n`) +
    `                , null, request, authentication, new ValidateAuthList(${value.system_table_auth_str}), map, null);\r\n` +
    `    }\r\n` +
    `    @RequestMapping("/api/${value.system_table_path}/code")\r\n` +
    `    public Header<?> get${value.system_table_page_name}CodeList(HttpServletRequest request, Authentication authentication,\r\n` +
    `            @RequestBody(required = false) Map<String, Object> map) {\r\n` +
    `        return Header.SQL("GETLIST-${value.system_table_mapper}.select${value.system_table_page_name}CodeList/auth-user_seq", null, request, authentication, new ValidateAuthList(${value.system_table_auth_str}), map, null);\r\n` +
    `    }`;

  const authuserfield_fixedstr =
    !checkEmpty(value.system_select_auth)
      ? value.system_select_auth
          .map((item: string) => {
            //권한설정관련
            const str = strCapitalize(item);
            const field_name = "system_" + item + "_auth_field";
            return !checkEmpty(value[field_name])
              ? `                AND <include refid="common.check${str}UserAuth"><property name="user_auth" value="${value[field_name]}" /></include>\r\n`
              : "";
          })
          .join("")
      : "";
  const authusername_fixedstr =
  !checkEmpty(value.system_select_auth)
      ? value.system_select_auth
          .map((item: string) => {
            const str = strCapitalize(item);
            return `            <include refid="common.select${str}UserName" />,\r\n`;
          })
          .join("")
      : "";

  const common_fixedstr =
    `    <sql id="bind${value.system_table_page_name}Pk"><include refid="common.bindPkList">\r\n` +
    `            <property name="pkListStr" value="${value.system_table_pk.join(",")}" />\r\n` +
    `    </include></sql>\r\n` +
    `    <sql id="bind${value.system_table_page_name}List"><include refid="common.bindFieldList">\r\n` +
    `            <property name="fieldListStr" value="${fields.list.join(",")}" />\r\n` +
    `    </include></sql>\r\n` +
    `    <sql id="bind${value.system_table_page_name}Common"><include refid="common.bindFieldList">\r\n` +
    `            <property name="fieldListStr" value="${fields.read.join(",")}" />\r\n` +
    `    </include></sql>\r\n` +
    `    <sql id="bind${value.system_table_page_name}Detail">\r\n` +
    `        <include refid="bind${value.system_table_page_name}Common" />\r\n` +
    `        <!-- <include refid="common.bindFieldList">\r\n` +
    `            <property name="fieldListStr" value="${fields.read.join(",")}" />\r\n` +
    `        </include> -->\r\n` +
    `    </sql>\r\n` +
    `    <sql id="bind${value.system_table_page_name}Insert">\r\n` +
    `        <include refid="bind${value.system_table_page_name}Common" />\r\n` +
    `        <!-- <include refid="common.bindFieldList">\r\n` +
    `            <property name="fieldListStr" value="${fields.insert.join(",")}" />\r\n` +
    `        </include> -->\r\n` +
    `    </sql>\r\n` +
    `    <sql id="bind${value.system_table_page_name}Update">\r\n` +
    `        <include refid="bind${value.system_table_page_name}Common" />\r\n` +
    `        <!-- <include refid="common.bindFieldList">\r\n` +
    `            <property name="fieldListStr" value="${fields.update.join(",")}" />\r\n` +
    `        </include> -->\r\n` +
    `    </sql>\r\n` +
    `    <sql id="bind${value.system_table_page_name}Code">\r\n` +
    `        <include refid="bind${value.system_table_page_name}Common" />\r\n` +
    `        <!-- <include refid="common.bindFieldList">\r\n` +
    `            <property name="fieldListStr" value="${fields.read.join(",")}" />\r\n` +
    `        </include> -->\r\n` +
    `    </sql>\r\n` +
    `    <sql id="table${value.system_table_page_name}">${value.system_TABLE_SCHEMA}.${value.system_TABLE_NAME}</sql>\r\n` +
    `    <sql id="select${value.system_table_page_name}CommonWhere">\r\n` +
    `        WHERE 1=0\r\n` +
    (!checkEmpty(value.system_select_auth) && value.system_select_auth.length > 0
      ? `            <if test="` +
        value.system_select_auth.map((item: string) => getMybatisEqStr(item + "_seq")).join(" and ") +
        `">\r\n` +
        `            OR (` +
        value.system_select_auth.map((item: string) => getSqlEq(item + "_seq")).join(" AND ") +
        `\r\n`
      : "            OR ( 1 = 1 ") +
    `                    ${fields.search_str}\r\n` +
    (fields.search_select_str !== ""
      ? `                <if test="searchType!=null and !searchType.equals('') and searchTitle!=null and !searchTitle.equals('')">\r\n` +
        `                    ${fields.search_select_str}\r\n` +
        `                </if>\r\n`
      : "") +
    //권한설정관련
    authuserfield_fixedstr +
    `            )\r\n` +
    (!checkEmpty(value.system_select_auth) && value.system_select_auth.length > 0 ? `            </if>\r\n` : "") +
    `    </sql>\r\n`;
  const order_fixedstr =
    `        ORDER BY\r\n` +
    `        <choose>${fields.order_str}\r\n` +
    `            <otherwise>\r\n` +
    `                <include refid="common.ifLocaleEn"><property name="if_locale_order" value="${value.system_table_default_name_column}" /><property name="if_en_order" value="${value.system_table_en_name_column}" /></include>\r\n` +
    `            </otherwise>\r\n` +
    `        </choose>\r\n`;

  const mybatis_fixedstr =
    `    <!-- ${value.system_table_page_name} Start -->\r\n${common_fixedstr}` +
    `    \r\n` +
    `    <select id="select${value.system_table_page_name}List" parameterType="hashmap" resultType="linkmap">\r\n` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? `        <include refid="bind${value.system_table_page_name}Pk" />\r\n`
      : "") +
    `        <include refid="bind${value.system_table_page_name}List" />\r\n` +
    `       SELECT\r\n` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? "            <foreach collection='pkList' item='collection_pk' separator=','>${collection_pk}</foreach>,\r\n"
      : "") +
    "            <foreach collection='fieldList' item='collection_field' separator=','>${collection_field}</foreach>\r\n" +
    `        FROM\r\n` +
    `            <include refid="table${value.system_table_page_name}" />\r\n` +
    `        <include refid="select${value.system_table_page_name}CommonWhere" />\r\n` +
    `        ${order_fixedstr}\r\n` +
    `        <include refid="common.limitPage" />\r\n` +
    `    </select>\r\n` +
    `    <select id="select${value.system_table_page_name}ListCount" parameterType="hashmap" resultType="int">\r\n` +
    `        SELECT\r\n` +
    `            count(*)\r\n` +
    `        FROM\r\n` +
    `            <include refid="table${value.system_table_page_name}" />\r\n` +
    `        <include refid="select${value.system_table_page_name}CommonWhere" />\r\n` +
    `    </select>\r\n` +
    `    <select id="select${value.system_table_page_name}Detail" parameterType="hashmap" resultType="linkmap">\r\n` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? `        <include refid="bind${value.system_table_page_name}Pk" />\r\n`
      : "") +
    `        <include refid="bind${value.system_table_page_name}Detail" />\r\n` +
    `        SELECT\r\n` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? "            <foreach collection='pkList' item='collection_pk' separator=','>${collection_pk}</foreach>,\r\n"
      : "") +
    "            <foreach collection='fieldList' item='collection_field' separator=','>${collection_field}</foreach>,\r\n" +
    //권한설정관련
    authusername_fixedstr +
    `            <include refid="common.rgstDetail" />\r\n` +
    `        FROM <include refid="table${value.system_table_page_name}" /> rl\r\n` +
    `        WHERE\r\n` +
    `            1=0` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? `${getMybatisEqListFront(value.system_table_pk)}\r\n` +
        `            OR (\r\n` +
        "                <foreach collection='pkList' item='collection_pk' separator=' AND '>${collection_pk} = #{${collection_pk}}</foreach>\r\n"
      : "") +
    authuserfield_fixedstr +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0 ? `            )</if>\r\n` : "") +
    `    </select>\r\n` +
    (checkEmpty(fields.pk_ai) && checkEmpty(value.system_table_manual_increment)
      ? `    <select id="select${value.system_table_page_name}Uniq" parameterType="java.util.HashMap" resultType="int">\r\n` +
        `           SELECT\r\n` +
        `           ${getMybatisEqListFront(value.system_table_pk, undefined, true)}1</if>\r\n` +
        `           ${getMybatisEqListFront(value.system_table_pk, undefined, false)}(SELECT count(*) FROM <include refid="table${
          value.system_table_page_name
        }" /> WHERE ${getMybatisEqListInner(value.system_table_pk)})</if>\r\n` +
        `           as cnt FROM DUAL\r\n` +
        `    </select>\r\n`
      : "") +
    `    <insert id="insert${value.system_table_page_name}Detail" parameterType="java.util.HashMap"` +
    (fields.pk_ai.length === 1 ? ` useGeneratedKeys="true" keyProperty="${fields.pk_ai.join("")}"` : "") +
    `>\r\n` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? `        <include refid="bind${value.system_table_page_name}Pk" />\r\n`
      : "") +
    `        <include refid="bind${value.system_table_page_name}Insert" />\r\n` +
    (fields.pk_ai.length === 0 && !checkEmpty(value.system_table_manual_increment)
      ? `        <selectKey keyProperty="${value.system_table_manual_increment}" resultType="int" order="BEFORE">\r\n` +
        `        SELECT COALESCE(max(${value.system_table_manual_increment}),0) + 1 as seq from <include refid="table${value.system_table_page_name}" /> where ` +
        getMybatisEqListInner(
          value.system_table_pk.filter((item: string) => item !== value.system_table_manual_increment)
        ) +
        `\r\n` +
        `        </selectKey>\r\n`
      : "") +
    `        INSERT INTO <include refid="table${value.system_table_page_name}" />\r\n` +
    `        (\r\n` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? "            <foreach collection='pkList' item='collection_pk' separator=','>${collection_pk}</foreach>,\r\n"
      : "") +
    "            <foreach collection='fieldList' item='collection_field' separator=','>${collection_field}</foreach>,\r\n" +
    `            <include refid="common.rgstField" />\r\n` +
    `        ) VALUES (\r\n` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? "            <foreach collection='pkList' item='collection_pk' separator=','>#{${collection_pk}}</foreach>,\r\n"
      : "") +
    "            <foreach collection='fieldList' item='collection_field' separator=','>#{${collection_field}}</foreach>,\r\n" +
    `            <include refid="common.rgstInsert" />\r\n` +
    `        )\r\n` +
    `    </insert>\r\n` +
    `    <update id="update${value.system_table_page_name}Detail" parameterType="java.util.HashMap">\r\n` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? `        <include refid="bind${value.system_table_page_name}Pk" />\r\n`
      : "") +
    `        <include refid="bind${value.system_table_page_name}Update" />\r\n` +
    `        UPDATE <include refid="table${value.system_table_page_name}" />\r\n` +
    `            <set>\r\n` +
    `            <foreach collection='fieldList' item='collection_field'>\r\n` +
    "                <if test='@MybatisUtil@checkUP(UPList,collection_field)'>${collection_field} = #{${collection_field}},</if>\r\n" +
    `            </foreach>\r\n` +
    `            <include refid="common.rgstUpdate" />\r\n` +
    `            </set>\r\n` +
    `        WHERE\r\n` +
    `            1=0<if test="` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? getMybatisEqStrJoin(value.system_table_pk) + " and "
      : "") +
    `@MybatisUtil@checkUPList(UPList,fieldList)">\r\n` +
    `            OR (\r\n` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? "                <foreach collection='pkList' item='collection_pk' separator=' AND '>${collection_pk} = #{${collection_pk}}</foreach>\r\n"
      : "") +
    //권한설정관련
    authuserfield_fixedstr +
    `            )</if>\r\n` +
    `    </update>\r\n` +
    `    <select id="select${value.system_table_page_name}CodeList" parameterType="hashmap" resultType="linkmap">\r\n` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? `        <include refid="bind${value.system_table_page_name}Pk" />\r\n`
      : "") +
    `        <include refid="bind${value.system_table_page_name}Detail" />\r\n` +
    `        SELECT\r\n` +
    (value.system_table_pk !== undefined && value.system_table_pk.length > 0
      ? "            <foreach collection='pkList' item='collection_pk' separator=','>${collection_pk}</foreach>,\r\n"
      : "") +
    "            <foreach collection='fieldList' item='collection_field' separator=','>${collection_field}</foreach>,\r\n" +
    `            edit_at\r\n` +
    `        FROM <include refid="table${value.system_table_page_name}" />\r\n` +
    `        <include refid="select${value.system_table_page_name}CodeWhere" />\r\n` +
    `        <if test="last_edit_at != null  and !last_edit_at.equals('')">\r\n` +
    `        AND (SELECT COUNT(*) FROM <include refid="table${value.system_table_page_name}" /> <include refid="select${value.system_table_page_name}CodeWhere" />\r\n` +
    `        AND edit_at <![CDATA[>]]> #{last_edit_at}) <![CDATA[>]]> 0\r\n` +
    `        </if>\r\n` +
    `        <include refid="common.limitPage" />\r\n` +
    `    </select>\r\n` +
    `    <sql id="select${value.system_table_page_name}CodeWhere">\r\n` +
    `        WHERE (1=0\r\n` +
    (!checkEmpty(value.system_select_auth) && value.system_select_auth.length > 0
      ? `            <if test="` +
        value.system_select_auth.map((item: string) => getMybatisEqStr(item + "_seq")).join(" and ") +
        ` and user_seq != null and !user_seq.equals('')">\r\n` +
        `            OR (` +
        value.system_select_auth.map((item: string) => getSqlEq(item + "_seq")).join(" AND ") +
        `\r\n`
      : "            OR ( 1 = 1 ") +
    authuserfield_fixedstr +
    `            )\r\n` +
    (!checkEmpty(value.system_select_auth) && value.system_select_auth.length > 0 ? `            </if>\r\n` : "") +
    `            )\r\n` +
    (checkEmpty(value.system_table_use_column) ? "" : `        AND ${value.system_table_use_column} = 1\r\n`) +
    `    </sql>\r\n` +
    `    <!-- ${value.system_table_page_name} End -->`;

  const excelin_fixedstr = `="INSERT INTO ${value.system_TABLE_SCHEMA}.${value.system_TABLE_NAME} (${fields.excelin1_str}) VALUES (${fields.excelin2_str})"\r\n`;
  const excelup_fixedstr = `="UPDATE ${value.system_TABLE_SCHEMA}.${value.system_TABLE_NAME} SET ${fields.excelup_str} where ${value.system_table_pk_excel_str} "`;

  return {
    system_info_code: info_fixedstr,
    system_javascript_list: list_fixedstr,
    system_sql_common: common_fixedstr,
    system_sql_order: order_fixedstr,

    system_javascript_code: javascript_fixedstr,
    system_java_code: java_fixedstr,
    system_sql_query: mybatis_fixedstr,
    system_excel_insert: excelin_fixedstr,
    system_excel_update: excelup_fixedstr,
  };
};
